import {RANGE_ZONE_TEXTURE_KEYS} from '../../configs/fieldRangeZone';
import {hexDistance} from './sizeRecruitmentTextures';

/**
 * Штриховка ячейки, закрытой препятствием (см. configs/fieldRangeZone). Шестиугольник с вершиной
 * на оси x, как у ячеек поля; белый, цвет задает tint.
 *
 * Штрихи идут под таким углом и с таким шагом, что сетка ячеек переводит их сами в себя: на
 * соседних ячейках они продолжают друг друга, а не обрываются на общей стороне.
 */

export const RANGE_ZONE_HATCH_TEXTURE_SIZE = 128;
export const RANGE_ZONE_HATCH_RADIUS_PX = 62;

const APOTHEM_PX = RANGE_ZONE_HATCH_RADIUS_PX * Math.cos(Math.PI / 6);
// Смещение на соседнюю ячейку вдоль нормали штрихов — полторы стороны: это шесть шагов
const STRIPE_PERIOD_PX = (RANGE_ZONE_HATCH_RADIUS_PX * 1.5) / 6;
const STRIPE_NORMAL = {x: Math.cos(Math.PI / 3), y: Math.sin(Math.PI / 3)};
const STRIPE_FILL_SHARE = 0.34;

const clamp01 = (value) => Math.min(1, Math.max(0, value));

export const buildRangeZoneHatchPixels = () => {
  const size = RANGE_ZONE_HATCH_TEXTURE_SIZE;
  const pixels = new Uint8Array(size * size * 4);
  for (let y = 0; y < size; y += 1) {
    for (let x = 0; x < size; x += 1) {
      const offset = (y * size + x) * 4;
      const px = x + 0.5 - size / 2;
      const py = y + 0.5 - size / 2;
      const along = (px * STRIPE_NORMAL.x + py * STRIPE_NORMAL.y) / STRIPE_PERIOD_PX;
      const fromStripeCenter = Math.abs(along - Math.round(along)) * STRIPE_PERIOD_PX;
      const stripe = clamp01((STRIPE_PERIOD_PX * STRIPE_FILL_SHARE) / 2 + 0.5 - fromStripeCenter);
      const inside = clamp01(0.5 - hexDistance(px, py, APOTHEM_PX));
      pixels[offset] = 255;
      pixels[offset + 1] = 255;
      pixels[offset + 2] = 255;
      pixels[offset + 3] = Math.round(255 * stripe * inside);
    }
  }
  return pixels;
};

/**
 * Зарегистрировать текстуру один раз на сцену
 * @param {Phaser.Scene} scene
 * @param {Object} [options]
 * @param {number} [options.linearFilter] — режим фильтрации LINEAR
 * @returns {boolean} готова ли текстура
 */
export const ensureRangeZoneTextures = (scene, {linearFilter} = {}) => {
  const textures = scene?.textures;
  if (!textures?.exists || !textures.addUint8Array) {
    return false;
  }
  const key = RANGE_ZONE_TEXTURE_KEYS.HATCH;
  if (textures.exists(key)) {
    return true;
  }
  const size = RANGE_ZONE_HATCH_TEXTURE_SIZE;
  const texture = textures.addUint8Array(key, buildRangeZoneHatchPixels(), size, size);
  if (!texture) {
    return false;
  }
  if (linearFilter !== undefined) {
    texture.setFilter?.(linearFilter);
  }
  return true;
};
